import { gql } from '@apollo/client'

const QUERY_MERCHANT_DISCOUNTS = gql`
  query getDiscounts(
    $page: Int!
    $search: String
    $merchantId: ID!
    $filter: DiscountFilter!
    $type: DiscountTrigger!
  ) {
    getMerchantDiscounts(
      merchantId: $merchantId
      page: $page
      filter: $filter
      type: $type
      search: $search
    ) {
      pageSize
      pageNumber
      totalPages
      totalEntries
      discounts {
        id
        code
        type
        value
        target
        trigger
        quantity
        end_date
        store_ids
        start_date
        description
        usage_count
        minimum_value
      }
    }
  }
`

const QUERY_MERCHANT_CONNECTED_CARDS = gql`
  query merchantConnectedStripeCards($merchantSlug: String) {
    cards: merchantConnectedStripeCards(merchantSlug: $merchantSlug) {
      id
      last4
      expMonth
      expYear
      defaultSource
    }
  }
`

const QUERY_MERCHANT_STRIPE_ACCOUNT_SESSION = gql`
  query getMerchantStripeAccountSession($merchantSlug: String!) {
    getMerchantStripeAccountSession(merchantSlug: $merchantSlug) {
      account
      clientSecret
      publicKey
      expiresAt
      livemode
      object
    }
  }
`

export {
  QUERY_MERCHANT_DISCOUNTS,
  QUERY_MERCHANT_CONNECTED_CARDS,
  QUERY_MERCHANT_STRIPE_ACCOUNT_SESSION
}
